import '@ionic/core';

import '../case-information-view/case-information-view';
import '../clinic-information-view/clinic-information-view';
import '../interest-form-view/interest-form-view';
import '../social-view/social-view';

import { Component, Element, getAssetPath, h, Prop, State } from '@stencil/core';

@Component({
  tag: 'opportunity-card',
  styleUrl: 'opportunity-card.css',
  shadow: true,
  assetsDirs: ['assets']
})
export class OpportunityCard {
    @Prop({ attribute: 'cohort-id' }) opportunityCohortId: number = 1000;
    @Prop({ attribute: 'opportunity-type' }) opportunityType: string = 'clinic';
    @Prop({ attribute: 'opportunity-id' }) opportunityId: number = 863;
    @Prop({ attribute: 'opportunity-title' }) opportunityTitle: string = 'Short Case Title That Sets The Theme';
    @Prop({ attribute: 'opportunity-summary' }) opportunitySummary: string = "Case summary with <em>(IMPORTANT)</em>, #SpeaksSpanish but not all, details #SpeaksQ'anjob’al that volunteers might find helpful. #Remote #Mentorship #SpeaksEsperanto";
    @Prop({ attribute: 'loc-county' }) opportunityCounty: string = 'los angeles';
    @Prop({ attribute: 'loc-state' }) opportunityStateAbbr: string = 'ca';
    @Prop({ attribute: 'opportunity-category' }) opportunityCategoryCode: number = 9;
    @Prop({ attribute: 'partner-opportunity-id' }) opportunityPartnerCaseId: string = '20-111111';
    @Prop({ attribute: 'partner-id' }) opportunityPartnerId: number = 0;
    @Prop({ attribute: 'partner-name' }) opportunityPartnerName: string = 'World\'s Best Legal Aid';
    @Prop({ attribute: 'clinic-sessions' }) clinicSessions: any[] | string = [
        {clinic_session_id: '7e534da3-b56f-4938-8984-a61a34c45c59', start_date_time:'2021-01-01T17:00:00+ET', end_date_time:'2021-01-01T17:00:00+ET'},
        {clinic_session_id: '7e534da3-b56f-4938-8984-a61a34c45c59', start_date_time:'2021-01-05T18:10:00+ET', end_date_time:'2021-01-05T18:11:00+ET'},
        {clinic_session_id: '7e534da3-b56f-4938-8984-a61a34c45c59', start_date_time:'2021-01-01T19:00:00+ET', end_date_time:'2021-01-01T19:00:00+ET'},
        {clinic_session_id: '7e534da3-b56f-4938-8984-a61a34c45c59', start_date_time:'2021-01-05T20:10:00+ET', end_date_time:'2021-01-05T20:11:00+ET'},
    ];

    @Prop() volunteerName: string;
    @Prop() volunteerEmail: string;
    @Prop() volunteerPhone: string;
    @Prop() volunteerBarNo: string;

    @State() iconFilename = ''
    @State() iconDescription = '';

    @Element() el: HTMLElement;

    componentWillLoad() {
        this.setOpportunityIcon(this.opportunityCategoryCode);
    }

    componentWillRender() {
        this.setOpportunityIcon(this.opportunityCategoryCode);
    }

    private setOpportunityIcon(categoryCode: number) {
        const basePath = '../../assets/case-type-icons/'

        if ((categoryCode > 1) && ((categoryCode <= 10))) {
            this.iconFilename = basePath.concat('Consumer.png')
            this.iconDescription = 'A drawing of a stack of dollar bills and a pair of scales.'
        } else if ((categoryCode >= 11) && ((categoryCode <= 20))) {
            this.iconFilename = basePath.concat('Education.png')
            this.iconDescription = 'A drawing of three books stacked on top of each other.'
        } else if ((categoryCode >= 21) && ((categoryCode <= 29))) {
            this.iconFilename = basePath.concat('Employment.png')
            this.iconDescription = 'A drawing of a laptop computer.'
        } else if ((categoryCode >= 30) && ((categoryCode <= 40))) {
            this.iconFilename = basePath.concat('Family.png')
            this.iconDescription = 'A drawing of two people with a heart above them.'
        } else if ((categoryCode >= 41) && ((categoryCode <= 50))) {
            this.iconFilename = basePath.concat('Juvenile.png')
            this.iconDescription = 'A drawing of two todlers.'
        } else if ((categoryCode >= 51) && ((categoryCode <= 60))) {
            this.iconFilename = basePath.concat('Health.png')
            this.iconDescription = 'A drawing of a stethascope.'
        } else if ((categoryCode >= 61) && ((categoryCode <= 70))) {
            this.iconFilename = basePath.concat('Housing.png')
            this.iconDescription = 'A drawing of a house.'
        } else if ((categoryCode >= 71) && ((categoryCode <= 80))) {
            this.iconFilename = basePath.concat('IncomeMaintenance.png')
            this.iconDescription = 'A drawing of a stack of dollar bills.'
        } else if ((categoryCode >= 81) && ((categoryCode <= 90))) {
            this.iconFilename = basePath.concat('IndividualRights.png')
            this.iconDescription = 'A drawing of a set of scales.'
        } else {
            this.iconFilename = basePath.concat('Miscellaneous.png')
            this.iconDescription = 'A drawing of a box labeled "Misc".'
        }
    }

    private switchToNarrativePanel() {
        if (this.opportunityType.toLowerCase() === 'clinic') {
            this.el.shadowRoot.querySelector('clinic-information-view').classList.remove("HiddenPanel")
        } else {
            this.el.shadowRoot.querySelector('case-information-view').classList.remove("HiddenPanel")
        }
        
        this.el.shadowRoot.querySelector('interest-form-view').classList.add("HiddenPanel")
        this.el.shadowRoot.querySelector('social-view').classList.add("HiddenPanel")

        this.el.shadowRoot.querySelector('ion-tab-bar > ion-tab-button:nth-of-type(1)').setAttribute("selected", "true")
        this.el.shadowRoot.querySelector('ion-tab-bar > ion-tab-button:nth-of-type(2)').setAttribute("selected", "false")
        this.el.shadowRoot.querySelector('ion-tab-bar > ion-tab-button:nth-of-type(3)').setAttribute("selected", "false")
    }

    private switchToRegistrationPanel() {
        if (this.opportunityType.toLowerCase() === 'clinic') {
            this.el.shadowRoot.querySelector('clinic-information-view').classList.add("HiddenPanel")
        } else {
            this.el.shadowRoot.querySelector('case-information-view').classList.add("HiddenPanel")
        }

        this.el.shadowRoot.querySelector('interest-form-view').classList.remove("HiddenPanel")
        this.el.shadowRoot.querySelector('social-view').classList.add("HiddenPanel")

        this.el.shadowRoot.querySelector('ion-tab-bar > ion-tab-button:nth-of-type(1)').setAttribute("selected", "false")
        this.el.shadowRoot.querySelector('ion-tab-bar > ion-tab-button:nth-of-type(2)').setAttribute("selected", "true")
        this.el.shadowRoot.querySelector('ion-tab-bar > ion-tab-button:nth-of-type(3)').setAttribute("selected", "false")
    }

    private switchToSharePanel() {
        if (this.opportunityType.toLowerCase() === 'clinic') {
            this.el.shadowRoot.querySelector('clinic-information-view').classList.add("HiddenPanel")
        } else {
            this.el.shadowRoot.querySelector('case-information-view').classList.add("HiddenPanel")
        }
        
        this.el.shadowRoot.querySelector('interest-form-view').classList.add("HiddenPanel")
        this.el.shadowRoot.querySelector('social-view').classList.remove("HiddenPanel")

        this.el.shadowRoot.querySelector('ion-tab-bar > ion-tab-button:nth-of-type(1)').setAttribute("selected", "false")
        this.el.shadowRoot.querySelector('ion-tab-bar > ion-tab-button:nth-of-type(2)').setAttribute("selected", "false")
        this.el.shadowRoot.querySelector('ion-tab-bar > ion-tab-button:nth-of-type(3)').setAttribute("selected", "true")
    }

    render() {
        let informationView

        if (this.opportunityType.toLowerCase() === 'clinic') {
            informationView = <clinic-information-view 
                class="CardContent" 
                cohort-id={this.opportunityCohortId} 
                opportunity-county={this.opportunityCounty} 
                opportunity-state={this.opportunityStateAbbr} 
                opportunity-summary={this.opportunitySummary} 
                clinic-sessions={this.clinicSessions} 
                partner-name={this.opportunityPartnerName} 
                partner-case-id={this.opportunityPartnerCaseId} />
        } else {
            informationView = <case-information-view 
                class="CardContent" 
                cohort-id={this.opportunityCohortId} 
                opportunity-county={this.opportunityCounty} 
                opportunity-state={this.opportunityStateAbbr} 
                opportunity-summary={this.opportunitySummary} 
                partner-name={this.opportunityPartnerName} 
                partner-case-id={this.opportunityPartnerCaseId} />
        }

        return (
            <ion-card>
                <ion-card-header>
                    <img src={getAssetPath(this.iconFilename)} alt={this.iconDescription} height="30" width="30" />
                    <ion-card-title>{this.opportunityTitle}</ion-card-title>
                    <div class="ClearBoth">&nbsp;</div>
                </ion-card-header>
                <ion-card-content>
                    {informationView}
                    <interest-form-view 
                        class="HiddenPanel CardContent" 
                        volunteer-name={this.volunteerName} 
                        volunteer-email={this.volunteerEmail} 
                        volunteer-phone-number={this.volunteerPhone} 
                        volunteer-bar-number={this.volunteerBarNo} 
                        cohort-id={this.opportunityCohortId}
                        partner-id={this.opportunityPartnerId} 
                        opportunity-id={this.opportunityId}
                        clinic-sessions={this.clinicSessions}
                        opportunity-type={this.opportunityType} />
                    <social-view 
                        class="HiddenPanel CardContent" 
                        cohort-id={this.opportunityCohortId}
                        partner-id={this.opportunityPartnerId} 
                        opportunity-id={this.opportunityId}
                        opportunity-type={this.opportunityType} />
                    <ion-tab-bar slot="bottom">
                        <ion-tab-button tab="tab-schedule" selected={true}
                            onClick={this.switchToNarrativePanel.bind(this)}>
                            <ion-icon name="information-circle"></ion-icon>
                            <ion-label>Case Info</ion-label>
                        </ion-tab-button>
                        <ion-tab-button tab="tab-speaker" onClick={this.switchToRegistrationPanel.bind(this)}>
                            <ion-icon name="clipboard"></ion-icon>
                            <ion-label>Interested?</ion-label>
                        </ion-tab-button>
                        <ion-tab-button tab="tab-speaker" onClick={this.switchToSharePanel.bind(this)}>
                            <ion-icon name="share"></ion-icon>
                            <ion-label>Share</ion-label>
                        </ion-tab-button>
                    </ion-tab-bar>
                </ion-card-content>
            </ion-card>
        );
    }
}
